import * as React from 'react';
import { LoadOptions } from 'app/types-shared';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { CodeActionType } from 'app/area/codetable/item/types';
import { CodeCodetablePickerProps } from 'app/area/codetable/item/code-pickers/types';
import { CodeSinglePicker } from 'app/area/codetable/common';
import { useEffect } from 'react';
import { getDisabledValidation } from 'app/area/shared/codetable/item/codetable-item-helpers';

import { manageOptionsButton } from 'app/area/shared/manage-options';

export const UnitOfMeasureCategory = ({ breadcrumbs, metadata, codeItem, onChange,
  loadOptions, fetchingParentCategory, options, translation,
  validation, readOnly, actionType, checkIsUomExcluded }: CodeCodetablePickerProps & {
    checkIsUomExcluded: (uomTypeId: number) => void;
  }) => {

  if (!metadata || !metadata.codetableCategory || !isDefinedIncludingZero(metadata.codetableCategory.id)) {
    return null;
  }

  useEffect(() => {
    isDefinedIncludingZero(codeItem.category?.value) && checkIsUomExcluded(codeItem.category?.value);
  }, [codeItem.category]);

  const onLoadOptions = (id: string, loadOptionsParams: LoadOptions) => {
    loadOptions(id, metadata.codetableCategory.id, { ...loadOptionsParams, ignoreCategoryFilters: true });
  };

  const extraFooterButton = manageOptionsButton(translation.manage_options, metadata.codetableCategory.id, breadcrumbs);

  const codeOptions = options?.category?.codes || [];

  const isCodeEditing = codeItem && isDefinedIncludingZero(codeItem.id);

  const isCodeDuplicating = actionType === CodeActionType.Duplicate;

  const categoryValidation = validation?.category;

  const finalValidation = {
    ...categoryValidation,
    ...getDisabledValidation(codeItem.category?.disabled, translation.selected_value_disabled)
  };

  const isCategoryReadOnly = fetchingParentCategory || (!isCodeDuplicating && (isCodeEditing || readOnly));

  return (
    <CodeSinglePicker
      id="category"
      label={metadata.codetableCategory.label ?? translation?.category}
      valueItem={codeItem && codeItem.category}
      searchRequired={metadata.codetableCategory.id && metadata.codetableCategory.searchRequired}
      required={!isCategoryReadOnly}
      options={codeOptions}
      fetchingOptions={(options.category && options.category.fetching)}
      showSpinnerLabel={fetchingParentCategory}
      validation={finalValidation}
      translation={translation}
      onLoadOptions={onLoadOptions}
      onChange={onChange}
      readOnly={isCategoryReadOnly}
      extraFooterButton={extraFooterButton}
    />
  );
};
